<template>
<div>

    <el-crud :baseUrl="'/employees/'+id+'/authorizedovertime'" 
        v-model="resource"
        :actions="[]"
        :config="crudConfig"
        :filters="filters"
        ref="crud">

        <template slot="crudFiltersDescription">
            <div>Fecha: <strong>{{filters.date_from}}</strong> a <strong>{{filters.date_to}}</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-date-picker
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una fecha">
                </el-date-picker>                
            </el-form-item>
        </template>

        <template slot="table">
            <el-table-column
                label="Fecha">
                <template slot-scope="scope">
                    {{scope.row.date}}
                </template>
            </el-table-column>
            <el-table-column
                label="Tiempo autorizado">
                <template slot-scope="scope">
                    {{scope.row.authorized_minutes}}
                </template>
            </el-table-column>
            <el-table-column
                label="Autorizador">
                <template slot-scope="scope">
                    {{scope.row.authorized_by}}
                </template>
            </el-table-column>
            <el-table-column
                label="Fecha Autorización">
                <template slot-scope="scope">
                    {{scope.row.authorized_on}}
                </template>
            </el-table-column>
        </template>

    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        name: 'employee-authorizedovertime',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                employee_id: null,
                crudConfig:{
                    level: 'L2',
                    // AddItemTitle: 'Asignar turno',
                    // DeleteItemConfirmMessage: 'Esto borrará permanentemente la asignación al turno. Desea continuar?'
                },
                resource:{
                    // shift_id: null,
                    // date_from: null,
                    // date_to: null,
                },
                filters: {
                    date_range: null,
                    date_from: null,
                    date_to: null,
                },
            };
        },
        components: {
            'el-crud': el_crud,
        },
        methods: {
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
        }
    }
</script>
